import React from 'react';
import { Button } from './ui/button';
import { Award, Users } from 'lucide-react';

const AboutSection = () => {
  const START_YEAR = 2017;
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = Math.max(0, currentYear - START_YEAR);

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 via-white to-green-50 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-100 rounded-full filter blur-3xl opacity-30 -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-100 rounded-full filter blur-3xl opacity-30 translate-y-1/2 -translate-x-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-green-400 to-green-600 rounded-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-300 blur-xl"></div>
            <img
              src="https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=800&q=80"
              alt="عن الشركة"
              className="relative rounded-3xl shadow-2xl w-full h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-500"
            />
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-green-500 to-green-700 text-white p-8 rounded-2xl shadow-2xl transform hover:rotate-3 transition-transform duration-300">
              <div className="text-4xl font-bold">2017</div>
              <div className="text-sm mt-1">منذ التأسيس</div>
            </div>
          </div>

          <div className="text-right" dir="rtl">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-semibold">معلومات عنا</span>
            </div>

            <h2 className="text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
              مرحبا بكم في
              <span className="bg-gradient-to-r from-green-600 to-green-500 bg-clip-text text-transparent"> الوسيط الناقل</span>
            </h2>

            <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-green-600 mb-8"></div>

            <p className="text-gray-600 text-xl leading-relaxed mb-6">
              تأسس الناقل الوسيط للنقل في عام 2017م ودشنت نشاطها بتقديم خدمات النقل الدولي والداخلي.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              نعمل على توفير أفضل خدمات النقل والشحن لعملائنا في جميع أنحاء اليمن والمملكة العربية السعودية بكل احترافية ودقة.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <Award className="w-10 h-10 text-green-600 mb-3" />
                <div className="text-3xl font-bold text-gray-900">+{yearsOfExperience}</div>
                <div className="text-gray-600 mt-1">سنوات من الخبرة</div>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
                <Users className="w-10 h-10 text-green-600 mb-3" />
                <div className="text-3xl font-bold text-gray-900">+1000</div>
                <div className="text-gray-600 mt-1">عميل راضٍ</div>
              </div>
            </div>

            <Button className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-10 py-7 text-lg font-bold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
              اقرأ المزيد
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
